var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMspRename(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47084_130354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99928 8.90094C7.86475 9.03539 7.6985 9.13812 7.51833 9.19819L5.77814 9.77823C5.65255 9.82013 5.52158 9.8414 5.38907 9.8414C5.06037 9.8414 4.75136 9.7134 4.51896 9.48098C4.18726 9.14919 4.0734 8.66674 4.22174 8.22177L4.80181 6.48167C4.86183 6.30145 4.96464 6.13509 5.09904 6.0007L8.85757 2.24219H1.50391C0.674652 2.24219 0 2.91684 0 3.74609V12.4961C0 13.3253 0.674652 14 1.50391 14H10.2539C11.0832 14 11.7578 13.3253 11.7578 12.4961V5.14243L7.99928 8.90094Z",
    fill: "#868D96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67872 6.58078C5.63368 6.62582 5.59978 6.6807 5.57965 6.7411L4.99958 8.48123C4.95044 8.62861 4.98881 8.79109 5.09865 8.90096C5.20851 9.01082 5.37099 9.04919 5.51837 9.00002L7.25853 8.41998C7.31896 8.39986 7.37381 8.36595 7.41885 8.32091L12.5426 3.19716L10.8025 1.45703L5.67872 6.58078Z",
    fill: "#868D96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0263 0.200218C12.7593 -0.0667393 12.3265 -0.0667393 12.0595 0.200218L11.3828 0.876948L13.123 2.6171L13.7997 1.94037C14.0667 1.67342 14.0667 1.24059 13.7997 0.973636L13.0263 0.200218Z",
    fill: "#868D96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47084_130354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMspRename);
export default __webpack_public_path__ + "static/media/msp_rename.4b65b4bb1215e25bd7462824a829a604.svg";
export { ForwardRef as ReactComponent };